import { DEFAULT_UI_THEME, isValidUiTheme, getSkinForTheme, type UiThemeId } from '@comp-sys/shared';

const DATA_THEME_ATTR = 'data-theme';
const DATA_SKIN_ATTR = 'data-skin';
const STORAGE_KEY = 'ui-theme';

/**
 * 把主题应用到 `<html>`：同时设置 data-theme（颜色 token）与 data-skin（形态家族）。
 *
 * 两个维度正交——颜色由 data-theme 决定，控件形态/氛围/动效由 data-skin 决定
 * （见 globals.css「形态家族皮肤」区块）。这让切换主题不仅是换色，而是换控件形态与场景氛围。
 *
 * 未知 / 缺失值回退到 DEFAULT_UI_THEME（glass），保证 DOM 始终有合法主题与家族。
 */
export function applyUiTheme(theme: string | null | undefined): void {
  const id: UiThemeId = theme && isValidUiTheme(theme) ? theme : DEFAULT_UI_THEME;
  const root = document.documentElement;
  root.setAttribute(DATA_THEME_ATTR, id);
  root.setAttribute(DATA_SKIN_ATTR, getSkinForTheme(id));
}

/** 读取 localStorage 缓存的主题（用于首屏快速应用，避免等待 API 时的闪烁）。 */
export function getCachedUiTheme(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) || DEFAULT_UI_THEME;
  } catch {
    return DEFAULT_UI_THEME;
  }
}

/** 缓存当前主题到 localStorage（与下次首屏一致）。 */
export function cacheUiTheme(theme: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // localStorage 不可用时静默忽略
  }
}
